export default __webpack_public_path__ + "static/media/mana15.236d17d1.svg";